export const VARIANTS = {
  OUTLINE: 'outline'
}
